import React from 'react';

import { useHotelSearchForm } from './hooks/useHotelSearchForm';
import { submitHotelSearch } from './helpers/submitHotelSearch';

import SearchPanel from '@shared/components/SearchPanel';

import { Grid, Typography, Box } from '@mui/material';

import DateRangeGit from '@shared/components/CustomDatePicker';

import ReferenceSearch from './components/ReferenceSearch';
import RoomButtonAndModal from './components/RoomButtonAndModal';
import ErrorMessage from './components/ErrorMessage';

import { SearchButtonWrapper } from '@shared/components/SearchButtonWrapper';

const FormSearchHotel = ({
  isDetailPage = false,
  isHomePage = false,
  setReady,
  needsNavigate,
  setIsLoadingResults = () => {},
  setIsLoadingFastResults = () => {},
  setHotelSearchResults = () => {},
  setHotelFastSearchResults = () => {},
  setHotReferenceCities = () => {},
}) => {
  const {
    hasError,
    roomInfo,
    setRoomInfo,
    showRooms,
    setShowRooms,
    quantity,
    setQuantity,
    updateCalendarValues,
    lodgingSelection,
    setLodgingSelection,
    updatepassengerValues,
    image,
    calendarValue,
    dispatch,
    passengerValue,
    setHasError,
    searchInfo,
    user,
    fetchData,
  } = useHotelSearchForm({
    isDetailPage,
    isHomePage,
    setIsLoadingResults,
    setIsLoadingFastResults,
    setHotelSearchResults,
    setHotelFastSearchResults,
    setHotReferenceCities,
  });

  const handleSubmit = () => {
    submitHotelSearch({
      lodgingSelection,
      roomInfo,
      quantity,
      needsNavigate,
      setShowRooms,
      calendarValue,
      dispatch,
      passengerValue,
      setHasError,
      setReady,
      searchInfo,
      user,
      fetchData,
    });
  };

  const INPUT_HEIGHT = '56px';

  return (
    <SearchPanel title="Alojamientos" image={image}>
      <Grid
        container
        rowSpacing={{ xs: 3, sm: 2 }}
        columnSpacing={{ xs: 1, sm: 2 }}
        alignItems="center"
        style={{ padding: '0px 0px 16px 0px' }}
      >
        {/* Subtitle */}
        <Grid
          item
          xs={12}
          sx={{
            pt: '4px !important',
            display: { xs: 'flex', sm: 'none' },
            alignItems: 'flex-start',
          }}
        >
          <Typography
            sx={{
              color: '#000',
              fontSize: '1.2rem',
              fontWeight: 600,
              m: 0,
            }}
          >
            Buscá ofertas en hoteles y mucho más
          </Typography>
        </Grid>

        {/* City input */}
        <Grid item xs={12} sm={6} md={4} sx={{ pt: { xs: '16px !important' } }}>
          <Box
            sx={{
              height: INPUT_HEIGHT,
              display: 'flex',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <ReferenceSearch
              lodgingSelection={
                lodgingSelection && Object.keys(lodgingSelection).length > 0
                  ? lodgingSelection
                  : null
              }
              setLodgingSelection={data => {
                if (data)
                  try {
                    if (window.opc) window.opc();
                  } catch (error) {
                    console.error('form-search-err', error);
                  }
                setLodgingSelection(data);
              }}
            />
          </Box>
        </Grid>

        {/* Date input */}
        <Grid item xs={12} sm={6} md={4}>
          <Box
            sx={{
              height: INPUT_HEIGHT,
              //display: 'flex',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <DateRangeGit
              checkInParam={searchInfo?.checkIn}
              checkOutParam={searchInfo?.checkOut}
              placeholders={{ startDate: 'Salida', endDate: 'Regreso' }}
              dateInfo={({ check_in, check_out, total_nights }) => {
                updateCalendarValues({ check_in, check_out, total_nights });
              }}
            />
          </Box>
        </Grid>

        {/* Room selector */}
        <Grid item xs={12} md={3}>
          <Box
            sx={{
              height: INPUT_HEIGHT,
              display: 'flex',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <RoomButtonAndModal
              roomInfo={roomInfo}
              setRoomInfo={setRoomInfo}
              quantity={quantity}
              setQuantity={setQuantity}
              showRooms={showRooms}
              setShowRooms={setShowRooms}
              updatepassengerValues={updatepassengerValues}
            />
          </Box>
        </Grid>

        {/* Search button */}
        <SearchButtonWrapper
          md={1}
          id="hotelSearchButton"
          onClick={handleSubmit}
          label="BUSCAR"
          containerSx={{
            height: INPUT_HEIGHT,
            display: 'flex',
            alignItems: 'center',
          }}
          buttonSx={{ height: INPUT_HEIGHT }}
        />
      </Grid>

      {/* Error message */}
      <ErrorMessage hasError={hasError} />
    </SearchPanel>
  );
};

export default FormSearchHotel;
